<template>
  <div id="app">
    <v-app id="inspire">
      <v-main class="login-container">
        <v-container class="fill-height" fluid>
          <v-row align="center" justify="center">
            <v-col cols="12" sm="8" md="6" lg="4">
              <div class="login-card">
                <!-- Logo grande en la parte superior -->
                <div class="logo-section">
                  <img src="../../assets/logo.png" class="main-logo" alt="Mas Servicios Asistenciales S.A de C.V" />
                </div>

                <!-- Header con título -->
                <div class="login-header">
                  <h1 class="welcome-title">Módulo de Finanzas</h1>
                </div>

                <!-- Formulario de Login -->
                <v-form ref="form" v-model="valid" class="login-form">
                  <div class="input-group">
                    <v-text-field
                      v-model.trim="username"
                      :rules="[rules.required]"
                      name="login"
                      placeholder="Usuario"
                      type="text"
                      outlined
                      rounded
                      class="custom-input"
                      @keyup.enter="submit"
                      :disabled="loginLoader"
                      hide-details="auto"
                      background-color="#f0f8ff"
                    />
                  </div>

                  <div class="input-group">
                    <v-text-field
                      id="password"
                      v-model.trim="password"
                      :rules="[rules.required]"
                      name="password"
                      placeholder="Contraseña"
                      :type="showPassword ? 'text' : 'password'"
                      outlined
                      rounded
                      class="custom-input"
                      @keyup.enter="submit"
                      :disabled="loginLoader"
                      :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                      @click:append="showPassword = !showPassword"
                      hide-details="auto"
                      background-color="#f0f8ff"
                    />
                  </div>

                  <v-btn
                    color="primary"
                    dark
                    x-large
                    rounded
                    block
                    class="login-button"
                    @click="submit"
                    :loading="loginLoader"
                    :disabled="!valid"
                  >
                    <v-icon left v-if="!loginLoader">mdi-login-variant</v-icon>
                    <v-progress-circular
                      v-else
                      indeterminate
                      color="white"
                      size="20"
                      width="2"
                      class="mr-2"
                    />
                    {{ loginText }}
                  </v-btn>
                </v-form>

                <!-- Footer -->
                <div class="form-footer">
                  <p class="footer-text">© {{ currentYear }} Mas Servicios Asistenciales S.A de C.V</p>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-main>
    </v-app>
  </div>
</template>

<script>
// @ is an alias to /src
import Vue from "vue";
import VueSweetalert2 from "vue-sweetalert2";
import swal from "sweetalert2";
import { setLocalStorage, getLocalStorage } from "../../utils/utils";
Vue.use(VueSweetalert2);
export default Vue.extend({
  data() {
    return {
      session: getLocalStorage("oSession") || {
	token: null,
	user: null,
	name: null,
	groups: null,
	valid: null,
	provider_id: null,
},
      valid: false,
      username: "",
      password: "",
      showPassword: false,
      loginLoader: false,
      loginText: "INICIAR SESIÓN",
      currentYear: new Date().getFullYear(),
      rules: {
        required: (value) => !!value || "Campo requerido",
      },
      toast: swal.mixin({
        toast: true,
        position: "top",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        onOpen: (toast) => {
          toast.addEventListener("mouseenter", swal.stopTimer);
          toast.addEventListener("mouseleave", swal.resumeTimer);
        },
      }),
    };
  },
  mounted() {

    if(this.session.token != null && this.session.valid != "false"){
      this.$router.push("/");
    }
    else {
      localStorage.clear();
    }
  },
  methods: {
    async submit() {

      swal.fire({
        title: 'Verificando credenciales...',
        showLoaderOnConfirm: true,
        icon: 'info',
        allowOutsideClick: false,
        timer: false,
        showConfirmButton: false,
        showLoaderOnConfirm: true,
        timerProgressBar: true,
        text: 'Validando acceso al sistema financiero...',
      });

      this.loginLoader = true;
      this.loginText = "Verificando...";
      const formData = new FormData();
      formData.append("username", this.username);
      formData.append("password", this.password);

      await this.axios
        .post("/api/login", formData)
        .then((response) => {
          console.log(response);
          this.loginLoader = false;
          this.loginText = "INICIAR SESIÓN";

          const session = {
            token: response.data.access,
            user: response.data.user,
            name: response.data.user,
            groups: response.data.groups,
            valid: "true",
            provider_id: response.data.groups == "Proveedor" ? response.data.provider_id : null,
          };
          
          this.session = session;
          setLocalStorage("oSession",session);
          swal.close();

          this.$router.push("/");
        })
        .catch((error) => {
          this.loginLoader = false;
          this.loginText = "INICIAR SESIÓN";
          console.log("errors :", error);
          this.toast.fire({
            icon: "error",
            title: "Credenciales inválidas. Verifica tu usuario y contraseña.",
          });
        });
    },
  },
});
</script>

<style scoped lang="scss">
// Estilos globales para prevenir deslizamiento vertical
* {
  box-sizing: border-box;
}

html, body {
  height: 100%;
  overflow-x: hidden;
  margin: 0;
  padding: 0;
}
// Variables de colores corporativos MAS SERVICIOS
$mas-blue: #1A3A6B;
$mas-blue-light: #4A9FD9;
$mas-blue-lighter: #79BCE1;
$mas-blue-lightest: #A0D2E7;
$mas-purple: #9B8BCB;
$mas-purple-light: #B8A8D9;
$mas-primary: #1d428a;

// Gradientes profesionales
$primary-gradient: linear-gradient(135deg, $mas-blue 0%, $mas-primary 100%);
$secondary-gradient: linear-gradient(135deg, $mas-blue-light 0%, $mas-blue-lighter 100%);
$accent-gradient: linear-gradient(135deg, $mas-purple 0%, $mas-purple-light 100%);
$light-gradient: linear-gradient(135deg, $mas-blue-lightest 0%, $mas-blue-lighter 100%);

// Contenedor principal sin deslizamiento vertical
.login-container {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 50%, #f1f5f9 100%);
  height: 100vh;
  max-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
  
  &::before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: 
      radial-gradient(circle at 20% 80%, rgba($mas-blue-lightest, 0.15) 0%, transparent 50%),
      radial-gradient(circle at 80% 20%, rgba($mas-purple-light, 0.15) 0%, transparent 50%),
      radial-gradient(circle at 40% 40%, rgba($mas-blue-lighter, 0.1) 0%, transparent 50%);
    pointer-events: none;
    z-index: 0;
  }
  
  > * {
    position: relative;
    z-index: 1;
  }
}

// Tarjeta de login profesional sin overflow
.login-card {
  width: 100%;
  max-width: 450px;
  max-height: 90vh;
  padding: 2rem 2rem;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 24px;
  box-shadow: 
    0 20px 40px rgba(0, 0, 0, 0.1),
    0 8px 32px rgba($mas-blue, 0.1),
    inset 0 1px 0 rgba(255, 255, 255, 0.8);
  border: 1px solid rgba(255, 255, 255, 0.2);
  margin: 0 auto;
  position: relative;
  overflow: hidden;
  overflow-y: auto;
  animation: slideInUp 0.8s ease-out;
  box-sizing: border-box;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: $primary-gradient;
    border-radius: 24px 24px 0 0;
  }
}

// Sección del logo optimizada
.logo-section {
  text-align: center;
  margin-bottom: 1.5rem;
  animation: fadeInDown 0.8s ease-out 0.2s both;
}

.main-logo {
  width: 160px;
  height: auto;
  filter: drop-shadow(0 8px 16px rgba($mas-blue, 0.2));
  transition: all 0.3s ease;
  
  &:hover {
    transform: scale(1.05);
    filter: drop-shadow(0 12px 24px rgba($mas-blue, 0.3));
  }
}

// Header con título optimizado
.login-header {
  text-align: center;
  margin-bottom: 2rem;
  animation: fadeInDown 0.8s ease-out 0.4s both;
}

.welcome-title {
  font-size: 1.8rem;
  font-weight: 600;
  background: $primary-gradient;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin: 0;
  text-align: center;
  line-height: 1.2;
  white-space: nowrap;
  text-shadow: 0 2px 4px rgba($mas-blue, 0.1);
}

// Formulario profesional
.login-form {
  width: 100%;
  animation: fadeInUp 0.8s ease-out 0.6s both;
}

.input-group {
  margin-bottom: 1rem;
  position: relative;
  
  &:nth-child(1) {
    animation: slideInLeft 0.8s ease-out 0.8s both;
  }
  
  &:nth-child(2) {
    animation: slideInRight 0.8s ease-out 1s both;
  }
}

// Campos de entrada mejorados
.custom-input {
  :deep(.v-input__control) {
    border-radius: 16px;
  }
  
  :deep(.v-text-field__outline) {
    border-color: rgba($mas-blue-lightest, 0.3);
    border-width: 2px;
    transition: all 0.3s ease;
  }
  
  :deep(.v-text-field--outlined.v-input--is-focused .v-text-field__outline) {
    border-color: $mas-blue;
    border-width: 2px;
    box-shadow: 0 0 0 3px rgba($mas-blue, 0.1);
  }
  
  :deep(.v-label) {
    display: none;
  }
  
  :deep(.v-input__slot) {
    background: rgba($mas-blue-lightest, 0.1) !important;
    backdrop-filter: blur(10px);
    border: 1px solid rgba($mas-blue-lightest, 0.2);
    transition: all 0.3s ease;
  }
  
  :deep(.v-text-field__outline) {
    border-color: transparent;
  }
  
  :deep(.v-text-field--outlined.v-input--is-focused .v-text-field__outline) {
    border-color: $mas-blue;
  }
  
  :deep(.v-input__slot:hover) {
    background: rgba($mas-blue-lightest, 0.15) !important;
    border-color: rgba($mas-blue-light, 0.3);
  }
  
  :deep(.v-input__slot:focus-within) {
    background: rgba($mas-blue-lightest, 0.2) !important;
    border-color: $mas-blue;
    box-shadow: 0 0 0 3px rgba($mas-blue, 0.1);
  }
  
  :deep(.v-text-field__details) {
    padding: 0 16px;
  }
  
  :deep(.v-messages__message) {
    color: $mas-blue;
    font-size: 0.875rem;
  }
}

// Botón de login con transiciones profesionales
.login-button {
  background: linear-gradient(
    135deg, 
    $mas-blue 0%, 
    $mas-primary 100%
  ) !important;
  color: white !important;
  font-weight: 600;
  font-size: 1rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  height: 48px;
  margin-bottom: 1.5rem;
  border-radius: 16px;
  box-shadow: 
    0 6px 20px rgba($mas-blue, 0.25),
    0 3px 10px rgba($mas-blue, 0.15),
    inset 0 1px 0 rgba(255, 255, 255, 0.15);
  position: relative;
  overflow: hidden;
  animation: fadeInUp 0.8s ease-out 1.2s both;
  border: 1px solid rgba(255, 255, 255, 0.1);
  
  // Efecto shimmer profesional
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg, 
      transparent, 
      rgba(255, 255, 255, 0.3), 
      transparent
    );
    transition: left 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }
  
  // Efecto de brillo en el borde
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 16px;
    padding: 1px;
    background: linear-gradient(
      135deg,
      rgba(255, 255, 255, 0.2) 0%,
      rgba(255, 255, 255, 0.05) 50%,
      rgba(255, 255, 255, 0.2) 100%
    );
    mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    mask-composite: xor;
    opacity: 0;
    transition: opacity 0.3s ease;
  }
  
  &:hover::before {
    left: 100%;
  }
  
  &:hover::after {
    opacity: 1;
  }
  
  &:hover {
    background: linear-gradient(
      135deg, 
      $mas-blue 0%, 
      $mas-blue-light 50%, 
      $mas-primary 100%
    ) !important;
    transform: translateY(-3px) scale(1.02);
    box-shadow: 
      0 12px 30px rgba($mas-blue, 0.35),
      0 6px 20px rgba($mas-blue, 0.25),
      0 3px 10px rgba($mas-primary, 0.15),
      inset 0 1px 0 rgba(255, 255, 255, 0.2);
    border-color: rgba(255, 255, 255, 0.2);
  }
  
  &:active {
    transform: translateY(-1px) scale(1.01);
    background: linear-gradient(
      135deg, 
      $mas-primary 0%, 
      $mas-blue 50%, 
      $mas-blue-light 100%
    ) !important;
    box-shadow: 
      0 6px 15px rgba($mas-blue, 0.25),
      0 3px 8px rgba($mas-blue, 0.15),
      inset 0 1px 0 rgba(255, 255, 255, 0.15);
    transition: all 0.1s ease;
  }
  
  &:focus {
    outline: none;
    box-shadow: 
      0 8px 25px rgba($mas-blue, 0.3),
      0 4px 15px rgba($mas-blue, 0.2),
      0 0 0 3px rgba($mas-blue-light, 0.3);
  }
  
  &:disabled {
    background: linear-gradient(135deg, #E0E0E0 0%, #F5F5F5 100%) !important;
    color: #999 !important;
    transform: none;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    border-color: rgba(0, 0, 0, 0.1);
    
    &::before,
    &::after {
      display: none;
    }
  }
  
  // Efecto de pulso sutil para llamar la atención
  &:not(:disabled):not(:active) {
    animation: subtlePulse 3s ease-in-out infinite;
  }
}

// Footer optimizado
.form-footer {
  text-align: center;
  margin-top: 1rem;
  animation: fadeInUp 0.8s ease-out 1.4s both;
}

.footer-text {
  color: rgba($mas-blue, 0.6);
  font-size: 0.8rem;
  margin: 0;
  font-weight: 400;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

// Animaciones profesionales
@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes subtlePulse {
  0%, 100% {
    box-shadow: 
      0 6px 20px rgba($mas-blue, 0.25),
      0 3px 10px rgba($mas-blue, 0.15),
      inset 0 1px 0 rgba(255, 255, 255, 0.15);
  }
  50% {
    box-shadow: 
      0 8px 25px rgba($mas-blue, 0.3),
      0 4px 15px rgba($mas-blue, 0.2),
      inset 0 1px 0 rgba(255, 255, 255, 0.2);
  }
}

// Diseño responsivo sin deslizamiento vertical
@media (max-width: 600px) {
  .login-container {
    padding: 1rem;
  }
  
  .login-card {
    padding: 1.5rem 1.5rem;
    margin: 0;
    max-width: 100%;
    max-height: 95vh;
    border-radius: 20px;
  }
  
  .logo-section {
    margin-bottom: 1rem;
  }
  
  .main-logo {
    width: 120px;
  }
  
  .login-header {
    margin-bottom: 1.5rem;
  }
  
  .welcome-title {
    font-size: 1.5rem;
  }
  
  .input-group {
    margin-bottom: 0.8rem;
  }
  
  .login-button {
    height: 44px;
    font-size: 0.9rem;
    margin-bottom: 1rem;
    transition: all 0.3s ease; // Transición más rápida en móvil
    
    &:hover {
      transform: translateY(-2px) scale(1.01); // Efecto más sutil en móvil
    }
  }
  
  .form-footer {
    margin-top: 0.8rem;
  }
  
  .custom-input {
    :deep(.v-input__control) {
      border-radius: 12px;
    }
  }
}

@media (max-width: 400px) {
  .login-container {
    padding: 0.5rem;
  }
  
  .login-card {
    padding: 1rem 1rem;
    max-height: 98vh;
    border-radius: 16px;
  }
  
  .logo-section {
    margin-bottom: 0.8rem;
  }
  
  .main-logo {
    width: 100px;
  }
  
  .login-header {
    margin-bottom: 1rem;
  }
  
  .welcome-title {
    font-size: 1.3rem;
  }
  
  .input-group {
    margin-bottom: 0.6rem;
  }
  
  .login-button {
    height: 40px;
    font-size: 0.8rem;
    margin-bottom: 0.8rem;
    transition: all 0.2s ease; // Transición muy rápida en móvil pequeño
    
    &:hover {
      transform: translateY(-1px) scale(1.005); // Efecto mínimo en móvil pequeño
    }
    
    // Desactivar animación de pulso en móviles pequeños
    &:not(:disabled):not(:active) {
      animation: none;
    }
  }
  
  .form-footer {
    margin-top: 0.6rem;
  }
  
  .footer-text {
    font-size: 0.7rem;
  }
}

// Efectos adicionales para pantallas grandes
@media (min-width: 1200px) {
  .login-card {
    max-width: 480px;
    padding: 3.5rem 3rem;
  }
  
  .main-logo {
    width: 200px;
  }
  
  .welcome-title {
    font-size: 2.4rem;
  }
}
</style>
